<template>
  <div>
    <box class="main-top-margin">
      <v-row dense>
        <v-col cols="12">
          <div v-if="isLoading" class="text-center ma-12">
            <v-progress-circular size="48" width="4" indeterminate color="grey lighten-2"></v-progress-circular>
          </div>

          <template v-else>
            <v-row dense>
              <v-col cols="12" class="px-2 py-6">
                <v-text-field v-model="client.name" :label="$t('CLIENT-LABEL-NAME')" required :rules="[rules.required, rules.name]"></v-text-field>

                <v-row align="end" class="ma-0 mb-5 pa-0 file-wrapper">
                  <v-file-input
                    accept="image/png, image/jpeg"
                    :placeholder="$t('GLOBAL-FILE_UPLOAD-CHOOSE_FILE')"
                    type="file"
                    prepend-icon=""
                    :label="$t('CLIENT-LABEL-LOGO_UPLOAD')"
                    :loading="isUploading ? 'green' : false"
                    :disabled="isUploading"
                    @change="imageUpload($event)"
                    @click:clear="imageRemove"
                    :key="editedItem"
                  >
                  </v-file-input>
                  <v-icon style="position: absolute; right: 0; bottom: 24px;">mdi-upload</v-icon>
                  <v-sheet
                    :key="editedItem"
                    color="grey lighten-3"
                    width="88px"
                    height="46px"
                    class="ml-4"
                    style="position: absolute; right: 22px; bottom: 26px; z-index: 1000; width: 88px; height: 46px; display: flex; align-items: center;"
                  >
                    <v-btn
                      v-if="client.logo != null"
                      fab
                      plain
                      x-small
                      absolute
                      style="z-index: 999; width: 18px; height: 18px; right: -6px; top: -6px;"
                      @click="imageRemove()"
                    >
                      <v-icon>mdi-close-circle</v-icon>
                    </v-btn>

                    <v-img max-height="28px" contain :src="getImgSrc()">
                      <template v-slot:placeholder>
                        <v-row class="fill-height ma-0" align="center" justify="center">
                          <v-progress-circular size="16" width="2" indeterminate color="grey darken-3"></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-sheet>
                </v-row>

                <v-select
                  v-model="client.language_id"
                  :items="languages"
                  item-text="label"
                  item-value="id"
                  :label="$t('CLIENT-LABEL-LANGUAGE')"
                  required
                  :rules="[rules.required]"
                >
                </v-select>

                <v-select v-model="client.unitSystem" :items="unitSystems" :label="$t('CLIENT-LABEL-UNIT_SYSTEM')" required :rules="[rules.required]">
                </v-select>
                <div class="wrapper">
                  <v-text-field v-model="client.primaryColor" :label="$t('CLIENT-LABEL-PRIMARY_COLOR')" />
                  <color-picker @pickedColor="client.primaryColor = $event" :color="client.primaryColor || undefined" />
                </div>
                <div class="wrapper">
                  <v-text-field v-model="client.secondaryColor" :label="$t('CLIENT-LABEL-SECONDARY_COLOR')"></v-text-field>
                  <color-picker @pickedColor="client.secondaryColor = $event" :color="client.secondaryColor || undefined" />
                </div>
                <v-divider class="my-4" style="border: none;"></v-divider>
              </v-col>
            </v-row>
          </template>
        </v-col>
      </v-row>
    </box>
    <box class="mt-2" background="transparent" borderColor="transparent" padding="1em 0">
      <div class="d-flex justify-end">
        <v-btn color="secondary" :loading="isSaving" bottom right @click="save()" style="z-index:999;">
          <small><lang t="GLOBAL-BTN-SAVE"/></small>
        </v-btn>
      </div>
    </box>
  </div>
</template>

<script>
import Box from "../../components/ui-elements/Box.vue";
import ColorPicker from "@/components/ui-elements/ColorPicker.vue";

export default {
  name: "Client",
  components: {
    Box,
    ColorPicker,
  },
  data() {
    return {
      isLoading: false,
      isSaving: false,
      isUploading: false,

      client: null,
    };
  },

  created() {
    if (this.$route.params.id) {
      this.initialize(this.$route.params.id);
    }
  },

  mounted() {},
  computed: {
    languages(){
      return this.$store.getters.getTranslatedLanguages;
    },
    unitSystems() {
      return [
        {
          text: this.$t("CLIENT-UNITSYSTEM-METRIC"),
          value: "metric",
        },
        {
          text: this.$t("CLIENT-UNITSYSTEM-IMPERIAL"),
          value: "imperial",
        },
      ];
    },
  },

  methods: {
    save() {
      this.isSaving = true;

      this.axios.put("mandates/" + this.client.id, this.client).then((res) => {
        this.isSaving = false;
        this.$store.dispatch("setSnackbar", { text: this.$t("GLOBAL-MESSAGE-SUCCESSFULLY_SAVED") });
      });
    },

    initialize(clientId) {
      this.isLoading = true;

      this.axios.get("mandates/" + clientId).then((res) => {
        this.client = res.data;

        setTimeout(() => {
          this.isLoading = false;
        }, 1000);

        this.changeTitle();
      });
    },

    changeTitle() {
      this.$route.meta.pageTitle = this.client.name;

      // Add a temporary query parameter.
      this.$router.replace({ query: { temp: Date.now() } });

      // Remove the temporary query parameter.
      this.$router.replace({ query: { temp: undefined } });
    },

    getImgSrc() {
      if (this.isUploading) {
        return false;
      }

      let imgUrl = false;

      if (this.client.logoTmp != null) {
        imgUrl = this.client.logoTmp;
      } else {
        imgUrl = this.client.logo != null ? this.$config.uploads + this.client.logo : false;
      }
      return imgUrl;
    },

    imageRemove() {
      this.client.logo = null;
      this.client.logoTmp = null;
      this.$forceUpdate();
    },

    imageUpload(file) {
      if (typeof file == "undefined" || file == null) {
        return false;
      }

      this.isUploading = true;

      let formData = new FormData();
      formData.append("file", file, file.name);

      // additional data
      formData.append("key", "file");

      this.axios
        .post("/upload", formData)
        .then((response) => {
          this.client.logo = response.data.filename;
          this.client.logoTmp = response.data.url;

          setTimeout(() => {
            this.isUploading = false;
          }, 1000);
        })
        .catch((error) => {
          console.error({ error });
        });
    },
  },
};
</script>

<style lang="scss">
.file-wrapper,
.wrapper {
  position: relative;
}
</style>
